<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="ic_steps_process" viewBox="0 0 12 12"><path id="사각형_148434" d="M0 0H12V1H0z" transform="translate(0 10.803)" fill="currentColor"/><path id="합치기_393" d="M8090 1575h3l-1.5 2Zm0-1v-9h3v9Z" transform="rotate(45 5938.128 -8972.654)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-step-process',
});
</script>
